import { useLocale } from '@va/localization';
import { getFormattedDateAndTime } from '@va/util/helpers';
import PropTypes from 'prop-types';

export const DateSinceCell = ({ value }) => {
  const { locale } = useLocale();
  return <span className='whitespace-nowrap'>{getFormattedDateAndTime(value, locale)}</span>;
};
DateSinceCell.propTypes = { value: PropTypes.number };
